import script from "./InteriorSection.vue?vue&type=script&setup=true&lang=js"
export * from "./InteriorSection.vue?vue&type=script&setup=true&lang=js"

import "./InteriorSection.vue?vue&type=style&index=0&id=022f86de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-022f86de"]])

export default __exports__